module.exports = __webpack_public_path__ + "img/cbd-mobile-active.11c89b7.svg";